// Reusable account picker dropdown — shows all user accounts, allows "no account".
import { useAccounts } from "@/lib/useAccounts";
import { useI18n } from "@/context/I18nContext";

export function AccountPicker({ value, onChange, testId = "acc-picker" }) {
  const { items = [] } = useAccounts();
  const { t } = useI18n();
  return (
    <select data-testid={testId} value={value || ""} onChange={(e) => onChange(e.target.value || null)}
      className="w-full px-4 py-3 rounded-2xl border border-border bg-card focus:border-primary focus:outline-none transition-colors">
      <option value="">—</option>
      {items.map((a) => (
        <option key={a.id} value={a.id}>
          {a.name} {a.currency ? `· ${a.currency}` : ""}
        </option>
      ))}
      {items.length === 0 && <option disabled>{t("noAccounts")}</option>}
    </select>
  );
}
